import { ITableHeader } from '@base/@types/components/Layout/TableGrid'
import { IParamsToSend } from '@base/@types/providers/Kpi/SalesProvider'

export const parseSalesKpiExportData = (
  headers: ITableHeader[],
  paramsToSend: IParamsToSend
) => {
  const headerFormatted = {
    configuracaoGrid: {
      data: headers[0].columns[0]?.show,

      centroCodigo: headers[1].columns[0]?.show,
      centroNome: headers[1].columns[1]?.show,

      gerenteCategoria: headers[2].columns[0]?.show,
      gerenteProtudo: headers[2].columns[1]?.show,

      mundoCodigo: headers[3].columns[0]?.show,
      mundoNome: headers[3].columns[1]?.show,

      categoriaCompactaCodigo: headers[4].columns[0]?.show,
      categoriaCompactaNome: headers[4].columns[1]?.show,

      categoriaCodigo: headers[5].columns[0]?.show,
      categoriaNome: headers[5].columns[1]?.show,

      status: headers[6].columns[0]?.show,

      curvaABC: headers[7].columns[0]?.show,

      empresaCodigo: headers[8].columns[0]?.show,
      empresaNome: headers[8].columns[1]?.show,

      rsReceitaBruta: headers[9].columns[0]?.show,
      rsReceitaLiquida: headers[9].columns[1]?.show,
      rsMetaReceitaLiquida: headers[9].columns[2]?.show,
      rsMetaReceitaLiquidaRealizada: headers[9].columns[3]?.show,
      btReceitaBruta: headers[9].columns[4]?.show,
      btReceitaLiquida: headers[9].columns[5]?.show,
      btMetaReceitaLiquida: headers[9].columns[6]?.show,
      btMetaReceitaLiquidaRealizada: headers[9].columns[7]?.show,

      margemLiquida: headers[10].columns[0]?.show,
      margemLiquidaAlvo: headers[10].columns[1]?.show,
      margemLiquidaPercentual: headers[10].columns[2]?.show,
      margemLiquidaPercentualAlvo: headers[10].columns[3]?.show
    }
  }

  return {
    ...paramsToSend,
    ...headerFormatted
  }
}
